import(/* webpackMode: "eager" */ "/opt/voicesphereai-frontend/src/components/loading-screen/loading-screen.jsx");
;
import(/* webpackMode: "eager" */ "/opt/voicesphereai-frontend/src/components/loading-screen/splash-screen.jsx");
